module.exports = __webpack_public_path__ + "static/media/leaderboard1.86150bfc.png";